import React, { useContext, useEffect, useState } from 'react';
import {
  getUser as getUserCookie,
  setUser as setUserCookie,
} from '@src/services/auth';

import type { ReactNode } from 'react';
import type { User } from '@src/services/auth';

type UserContextProps = User;

type UserUpdateContextProps = (user: User) => void;

type UserProviderProps = {
  children?: ReactNode | undefined;
};

const UserContext = React.createContext<UserContextProps | null>(null);
const UserUpdateContext = React.createContext<UserUpdateContextProps | null>(
  null
);

export function useUser() {
  return useContext(UserContext);
}

export function useUserUpdate() {
  return useContext(UserUpdateContext);
}

export function UserProvider({ children }: UserProviderProps) {
  const [user, setUser] = useState<User>(getUserCookie());

  function updateUser(user: User) {
    setUserCookie(user);
    setUser(user);
  }

  useEffect(() => {
    const userCookie = getUserCookie();
    setUser(userCookie);
  }, []);

  return (
    <UserContext.Provider value={user}>
      <UserUpdateContext.Provider value={updateUser}>
        {children}
      </UserUpdateContext.Provider>
    </UserContext.Provider>
  );
}
